import { render, staticRenderFns } from "./DataProfilingTab.vue?vue&type=template&id=7a428468&"
import script from "./DataProfilingTab.vue?vue&type=script&lang=ts&"
export * from "./DataProfilingTab.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports